import React from 'react'
import styles from './fileupload.module.css'
import IMAGES from '../../../../assets/images/images'
function FileUpload() {
    return (
        <div className={styles.mainContainer}>
              <div className={styles.subcontainer}>
                <div  className={styles.logo}><img src={IMAGES.attach}/></div>
                <div  className={styles.dragdrop}>Drag and drop file here</div>
                <div  className={styles.text}>The combined size of all files should be no more than 3 MB, with each file having a maximum size of 2 MB.</div>
                <div className={styles.button} >Browse</div>
              </div>
        </div>
    )
}

export default FileUpload
